// @flow

/**
 * Module dependencies.
 */

import { Col, Row } from 'client/components/core/grid';
import { StickyContainer } from 'react-sticky';
import { breakpoints, colors, fixedHeight } from 'client/styles';
import { compose } from 'recompose';
import { getNumbers, isMobile } from 'client/core/utils';
import { translator } from 'core/utils';
import Content from 'client/components/content';
import Header from 'client/components/header';
import Markdown from 'client/components/core/markdown';
import MediaQuery from 'react-responsive';
import PageContent from 'client/components/core/page-content';
import React, { Component } from 'react';
import ScrollTop from 'client/components/core/scroll-top';
import StickyNavbarTrigger from 'client/components/core/sticky-navbar/sticky-navbar-trigger';
import StickySidebar from 'client/components/legal-and-compliance/sticky-sidebar';
import entities from 'client/core/entities';

/**
 * `Props` type.
 */

type Props = {
  source: string,
  translate: Function
};

/**
 * `LegalContent` component.
 */

class LegalContent extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render side menu.
   */

  renderSideMenu(): React$Element<*> {
    const { translate } = this.props;
    const { legalSideMenu } = entities(translate);
    const top = Number(getNumbers(fixedHeight.navbar)) + 20;

    return (
      <MediaQuery minWidth={breakpoints.md}>
        <Col
          md={2}
          xs={10}
          xsOffset={1}
        >
          <StickySidebar
            fixedStyle={{ top }}
            items={legalSideMenu}
            topOffset={-top}
          />
        </Col>
      </MediaQuery>
    );
  }

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { source, translate } = this.props;

    return (
      <PageContent background={colors.shadesOfSand2.pampasDarker}>
        <Header
          filename={'hero-image'}
          title={translate('legalAndCompliance.title')}
        />

        <Content
          pullTop
          separator={isMobile()}
        >
          <StickyContainer>
            <StickyNavbarTrigger>
              <Row>
                {this.renderSideMenu()}

                <Col
                  md={6}
                  xs={10}
                  xsOffset={1}
                >
                  <Row>
                    <Col
                      lg={10}
                      xs={12}
                    >
                      <Markdown source={source} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </StickyNavbarTrigger>
          </StickyContainer>
        </Content>

        <ScrollTop />
      </PageContent>
    );
  }

}

/**
 * Export `LegalContent` component.
 */

export default compose(
  translator()
)(LegalContent);



// WEBPACK FOOTER //
// ../src/client/components/legal-and-compliance/legal-content.js